import { useLocation, Navigate, Outlet } from "react-router-dom"
import { useSelector } from "react-redux"
import { getUser } from "./authSlice"

const RequireAuth = () => {
    const user = useSelector(getUser)
    const location = useLocation()
    return (
        user
            ? <Outlet />
            : <Navigate to={`/login`} state={{ from: location }} replace />
    )
}
export default RequireAuth